import type * as React from "react";
import { Box, Typography } from "@mui/material";
import { SxProps } from "@mui/system";
import GlContentTag, {
  GlContentTagVariant
} from "components/v3/sharedComponents/GlContentTag";
import { COLORS } from "components/v3/Theme/colors";

type NextMoveCardProps = {
  body: React.ReactNode;
  id?: string;
  link: React.HTMLProps<HTMLAnchorElement> & {
    onClick?: () => void;
    overrideClick?: boolean;
    text: string;
    underline?: boolean;
    url: string;
  };
  sx?: SxProps;
  tag?: GlContentTagVariant;
  title: React.ReactNode;
};

const NextMoveCard: React.FC<NextMoveCardProps> = ({
  body,
  id,
  link,
  sx,
  tag,
  title
}) => {
  return (
    <Box
      component="a"
      href={link.url}
      id={id}
      onClick={(event) => {
        if (link.overrideClick) {
          event.preventDefault();
        }

        link.onClick?.();
      }}
      sx={{
        backgroundColor: COLORS.WHITE,
        border: `3px solid ${COLORS.PRIMARY_LIGHTEST}`,
        borderRadius: "16px",
        boxSizing: "border-box",
        color: "inherit",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        paddingX: 3,
        paddingY: 3,
        textDecoration: "none",
        transition: "border-color 0.2s ease",
        "&:hover": {
          borderColor: COLORS.ACCENT1_LIGHT
        },
        ...sx
      }}
      {...(link.target ? { target: link.target } : {})}
    >
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexWrap: "wrap",
          gap: 1
        }}
      >
        <Typography component="div" variant="body_strong_lg_black">
          {title}
        </Typography>
        {tag ? <GlContentTag variant={tag} /> : null}
      </Box>

      <Typography component="div" variant="body_black">
        {body}
      </Typography>

      <Typography
        sx={{ textDecoration: link.underline === false ? "none" : "underline" }}
        variant="body_strong_xs_dark_gray"
      >
        {link.text}
      </Typography>
    </Box>
  );
};

export default NextMoveCard;
